/**
 * AiENAiPageView
 *
 * Page component for AiENAiPageView
 * Path: /ai
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AiENAiPageView as __AiENAiPageView } from '@/components/traits/AiENAiPageView';
import { AiENAiAnalyticsView as __AiENAiAnalyticsView } from '@/components/traits/AiENAiAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface AiENAiPageViewProps {
  // Add any page-level props here
}

export function AiENAiPageView(_props: AiENAiPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-ai:meta.title"],"description":["i18n/t","std-almadar-ai:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/ai"},{"locale":"ar","path":"/ar/ai"},{"locale":"sl","path":"/sl/ai"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AiENAiPageView config={{ initPayload: __navState }} />
          <__AiENAiAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AiENAiPageView;
